import { defineFeatureService, } from '@oneaudi/sonic-feature-hub-tools';
import { I18NServiceV1Implementation, } from './v1/i18n-service-v1';
const definition = {
    id: 'dbad:audi-i18n-service',
    dependencies: {
        featureServices: {
            'locale-service': '1.0.0',
        },
    },
    optionalDependencies: {
        featureServices: {
            'audi-market-context-service': '1.0.0',
            's2:logger': '^1.0.0',
        },
    },
    versions: {
        '1.0.0': I18NServiceV1Implementation,
    },
};
const defineI18nService = defineFeatureService(definition);
export { defineI18nService, };
//# sourceMappingURL=feature-service.js.map